module.exports = __webpack_public_path__ + "static/media/Email.59176030.svg";